<template>
  <div id="covid" class="content container">    
    <h3>COVID-19 Information</h3>
    <small>Posted August 6th, 2020</small>
    <br><br>
    <p>Hello, the Garage Rats Car Club will not be
      hosting any events in the 2020 season due to the virus.</p>
    <p>Additionally, the Town of Erie has decided to cancel 2020 events.</p>
    <p>We look forward to hopefully seeing everyone again in 2021. Stay safe friends!</p>
    <p>
      To request any additional information, please visit our
      <router-link :to="{ name: 'Contact' }">contact page</router-link>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'CovidView'
}
</script>
